import {useFormik} from 'formik'
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import * as Yup from 'yup'
import UseYupValidate from '../../../../_gori/hooks/UseYupValidate'
import {Button, InputTextFormik} from '../../../../_gori/partials/widgets'
import {blockPopUp} from '../../../../_gori/helpers'
import {AcceptTermCheckbox} from '../../../../_gori/partials/widgets/form/AcceptTermCheckbox'
import {toast} from 'react-toastify'
import {InputCheckboxFormik} from '../../../../_gori/partials/widgets/form/InputCheckboxFormik'
import {useParams} from 'react-router-dom'
import AuthService from '../core/_requests'
import {isEmpty, isUndefined, lowerCase, startCase} from 'lodash'

export function TradeShow() {
  const intl = useIntl()
  const {authYup, infoYup, regexYup} = UseYupValidate()
  const [loading, setLoading] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)
  const {name, location} = useParams()
  const [dataTradeShow, setDataTradeShow] = useState<any>({
    active: true,
    form_token: null,
  })

  useEffect(() => {
    checkTradeShow()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkTradeShow()
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const checkTradeShow = async () => {
    try {
      const data = await AuthService.tradeShowCheck(name, location)

      setDataTradeShow({
        active: data.active,
      })
    } catch (error: any) {
      toast.error(error?.response?.data?.error?.message ?? intl.formatMessage({id: 'ERRORS'}))
    }
  }

  const registrationSchema = Yup.object().shape({
    company_name: authYup.companyName(50),
    first_name: regexYup.inputText('FIRST_NAME', true, 50),
    last_name: regexYup.inputText('LAST_NAME', true, 50),
    email: infoYup.email(),
    accept_terms: authYup.acceptTerms,
    receive_emails: authYup.receiveEmails,
  })

  const initialValues = {
    company_name: '',
    first_name: '',
    last_name: '',
    email: '',
    accept_terms: false,
    receive_emails: false,
    business_address: '',
  }

  const handleSubmitError = (errorsMessage: any) => {
    if (isEmpty(errorsMessage) || isUndefined(errorsMessage)) {
      return
    }

    Object.entries(errorsMessage).forEach(([key, value]: [any, any]) => {
      for (let i = 0; i < value.length; i++) {
        const errMessage = value[i].split('|')

        formik.errors[key] = formik.errors[key]
          ? formik.errors[key] +
            ', ' +
            intl.formatMessage({id: errMessage[1]}, {input: startCase(lowerCase(errMessage[0]))})
          : intl.formatMessage({id: errMessage[1]}, {input: startCase(lowerCase(errMessage[0]))})
      }
    })
  }

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        const payload = {
          ...values,
          form_token: dataTradeShow.form_token,
        }
        const response = await AuthService.tradeShowRegister(payload, name, location)
        toast.success(intl.formatMessage({id: response.message}))
        setLoading(false)
        setSuccess(true)
        formik.resetForm()
      } catch (error: any) {
        setLoading(false)
        handleSubmitError(error?.response?.data?.error?.fields)
      }
    },
  })

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        checkTradeShow()
        setSuccess(false)
      }, 5000)
    }
    // eslint-disable-next-line
  }, [success])

  return (
    <div className='bg-primary d-flex flex-center flex-column flex-column-fluid p-5'>
      {/* LOGO */}
      <div className='mb-12 text-center'>
        <img
          src='/media/logos/shipbae-gori-logo-white-trade-show.svg'
          alt='trade show registration'
          className='img-fluid w-75 w-md-2 w-lg-auto'
        />
      </div>
      <div className='fv-row mb-7 form-field-optional position-absolute start-0 top-0 overflow-hidden visually-hidden'>
        <InputTextFormik
          labelClassName='form-label fw-bolder text-dark fs-6'
          size='lg'
          formik={formik}
          name='business_address'
          type='text'
          autoComplete='business_address'
        />
      </div>

      {/* FORM WRAPPER */}
      {success ? (
        <div
          className='w-100 rounded shadow-sm p-4 p-md-5 p-lg-10'
          style={{
            maxWidth: '500px',
            backgroundColor: '#ECFFFD99',
          }}
        >
          <div className='p-6'>
            <div className={'text-center my-6'}>
              <p style={{fontSize: '36px', fontWeight: 'bold'}}>
                {intl.formatMessage({id: 'YOUR_ALL_SET'})}
              </p>
              <img
                src='/media/gori/orders/delivery-completed.gif'
                alt=''
                className='img-fluid w-25 w-md-2 w-lg-auto'
              />
            </div>
          </div>
        </div>
      ) : (
        <div
          className='w-100 rounded shadow-sm p-4 p-md-5 p-lg-10'
          style={{
            maxWidth: '600px',
            backgroundColor: '#ECFFFD99',
          }}
        >
          {dataTradeShow.active ? (
            <div className='form w-100'>
              {/* NAME */}
              <div className='row mb-4'>
                <div className='col-12 col-md-6 mb-4 mb-md-0'>
                  <InputTextFormik
                    labelClassName='form-label fw-bolder text-dark fs-6'
                    label={intl.formatMessage({id: 'FIRST_NAME'})}
                    size='lg'
                    formik={formik}
                    name='first_name'
                    required
                    disabled={formik.isSubmitting}
                  />
                </div>

                <div className='col-12 col-md-6'>
                  <InputTextFormik
                    labelClassName='form-label fw-bolder text-dark fs-6'
                    label={intl.formatMessage({id: 'LAST_NAME'})}
                    size='lg'
                    formik={formik}
                    name='last_name'
                    required
                    disabled={formik.isSubmitting}
                  />
                </div>
              </div>

              {/* EMAIL */}
              <div className='mb-4'>
                <InputTextFormik
                  labelClassName='form-label fw-bolder text-dark fs-6'
                  label={intl.formatMessage({id: 'EMAIL'})}
                  size='lg'
                  formik={formik}
                  name='email'
                  required
                  disabled={formik.isSubmitting}
                />
              </div>

              {/* COMPANY */}
              <div className='mb-4'>
                <InputTextFormik
                  labelClassName='form-label fw-bolder text-dark fs-6'
                  label={intl.formatMessage({id: 'COMPANY_NAME'})}
                  size='lg'
                  formik={formik}
                  name='company_name'
                  required
                  disabled={formik.isSubmitting}
                />
              </div>

              {/* TERMS */}
              <AcceptTermCheckbox
                alignTop
                className='mb-4'
                formik={formik}
                name='accept_terms'
                splitLabelCheck={[
                  intl.formatMessage({id: 'AGREE_MESSAGE_PRE_PHONE_VERIFY_1'}),
                  intl.formatMessage({id: 'AGREE_MESSAGE_PRE_PHONE_VERIFY_2'}),
                ]}
                links={[
                  {
                    label: intl.formatMessage({id: 'TERMS_OF_SERVICE'}),
                    onClick: () => {
                      if (blockPopUp('https://shipbae.com/service-terms')) {
                        toast.warning(intl.formatMessage({id: 'POP_UP_IS_BLOCKED'}))
                      }
                    },
                  },
                  {
                    label: intl.formatMessage({id: 'PRIVACY_POLICY'}),
                    onClick: () => {
                      if (blockPopUp('https://shipbae.com/privacy-policy')) {
                        toast.warning(intl.formatMessage({id: 'POP_UP_IS_BLOCKED'}))
                      }
                    },
                  },
                  {
                    label: intl.formatMessage({
                      id: 'USPS_LABEL_INTEGRITY_AND_COMPLIANCE_AGREEMENT',
                    }),
                    onClick: () => {
                      if (blockPopUp('https://shipbae.com/agreement')) {
                        toast.warning(intl.formatMessage({id: 'POP_UP_IS_BLOCKED'}))
                      }
                    },
                  },
                ]}
              />

              <InputCheckboxFormik
                formik={formik}
                className='mb-4 border-0'
                labelClassName={'text-gray-700'}
                inputClassName={'border-0'}
                type='checkbox'
                name='receive_emails'
                disabled={formik.isSubmitting}
                label={intl.formatMessage({id: 'TRADE_SHOW_RECEIVE_EMAIL'})}
              />

              {/* SUBMIT */}
              <Button
                className='btn btn-lg btn-advanced-primary w-100 rounded-pill'
                label={intl.formatMessage({id: 'SUBMIT'})}
                loadingText={intl.formatMessage({id: 'SUBMIT'})}
                loading={loading}
                disabled={loading}
                event={formik.submitForm}
                style={{backgroundColor: '#0B6D65'}}
              />
            </div>
          ) : (
            <div>
              <h2 className={'text-center text-danger'}>
                {intl.formatMessage({id: 'TRADE_SHOW_NOT_EXISTS'})}
              </h2>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
